import { getBaseApi } from "../api";
import type { BulkOrganisationPayload, Organisation, OrganisationMedia } from "../types";

const api = getBaseApi();

export const getOrganisations = async (filter: any) => {
  const response = await api.get(`/organisations?${new URLSearchParams(filter).toString()}`);
  return response.data;
};

export const getOrganisation = async (id: string) => {
  const response = await api.get(`/organisations/${id}`);
  return response.data?.data;
};

export const getOrganisationsSpotlight = async () => {
  const response = await api.get(`/organisations/spotlights`);
  return response.data?.data;
};

export const createOrganisation = async (data: Partial<Organisation>) => {
  return api.post(`/organisations`, data);
};

export const createBulkOrganisations = async (data: {organisations: BulkOrganisationPayload[]}) => {
  return api.post(`/organisations/bulk-with-mapping`, data);
};

export const updateOrganisation = async (id: string, data: any) => {
  return api.put(`/organisations/${id}`, data);
};

export const deleteOrganisation = async (id: string) => {
  return api.delete(`/organisations/${id}`);
};

export const deleteOrganisations = async (data: { organisationIds: string[] }) => {
  return api.post(`/organisations/delete-multiple`, data);
};

export const updateOrganisationVerification = async (id: string, data: any) => {
  return api.patch(`/organisations/${id}/verified`, data);
};

// Media
export const updateOrganisationMedia = async (id: string, data: { media: OrganisationMedia[] }) => {
  return api.post(`/organisations/${id}/media`, data);
};

export const deleteOrganisationMedias = async (id: string, mediaUrls: string[]) => {
  return api.delete(`/organisations/${id}/media`, {
    data: {
      urls: mediaUrls
    }
  });
};

// Projects
export const getOrganisationProjects = async (id: string) => {
  const response = await api.get(`/organisations/${id}/projects`);
  return response.data?.data;
};

// Users
export const getOrganisationUsers = async (id: string, filter: { page: number, limit: number }) => {
  const response = await api.get(`/organisations/${id}/users`, { params: filter });
  return response.data?.data;
};

export const updateOrganisationUserRole = async (id: string, userId: string, data: { role: string }) => {
  return api.patch(`/organisations/${id}/users/${userId}/role`, data);
};

export const deleteOrganisationUser = async (id: string, userId: string) => {
  return api.delete(`/organisations/${id}/users/${userId}`);
};

// Invitations
export const getOrganisationInvitations = async (id: string, filter: { page: number, limit: number }) => {
  const response = await api.get(`/organisations/${id}/invitations`, { params: filter });
  return response.data?.data;
};